// @ts-expect-error the installation guide recommends using the `ember-data/store` rather than `@ember-data/store`

import Store from 'ember-data/store';
import { service } from '@ember/service';

export default class ApplicationStore extends Store {
  @service requestManager: unknown;
}
